import { Injectable } from '@angular/core';
import { ChatService } from 'app/modules/admin/apps/chat/chat.service';
import { Chat, Profile } from 'app/modules/admin/apps/chat/chat.types';
import { Observable } from 'rxjs';

/**
 * Facade over the main {@link ChatService} so the quick-chat panel shares the same
 * real-time data, SignalR connection and presence/notification handling as the chat module.
 */
@Injectable({ providedIn: 'root' })
export class QuickChatService {
    constructor(private _chatService: ChatService) {}

    get chat$(): Observable<Chat> {
        return this._chatService.chat$;
    }

    get chats$(): Observable<Chat[]> {
        return this._chatService.chats$;
    }

    /** Total unread messages across all conversations (for the header chat-icon badge). */
    get totalUnread$(): Observable<number> {
        return this._chatService.totalUnread$;
    }

    /** Open the realtime connection (also flips this user online). */
    connect(): void {
        this._chatService.connect();
    }

    getChats(): Observable<Chat[]> {
        return this._chatService.getChats();
    }

    /** Loads the current user (needed so messages are tagged as mine/theirs). */
    getProfile(): Observable<Profile> {
        return this._chatService.getProfile();
    }

    getChatById(id: string): Observable<Chat> {
        return this._chatService.getChatById(id);
    }

    sendMessage(conversationId: string, content: string): void {
        this._chatService.sendMessage(conversationId, content);
    }
}
